import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useLessons(data = {}) {
  const { enabled = false, configs = {}, classID, courseID, chapterID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getLessons() {
    return privateFetch
      .get(`/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic`, configs)
      .then((res) => res.data);
  }

  return useQuery(['subject-chapter-lessons', { data }], getLessons, { enabled });
}

export default useLessons;
